import React from 'react'
import PropTypes from 'prop-types'

const Figure = ({ 
	id,
	d, 
	fill, 
	transform, 
	selected, 
	stroke, 
	strokeWidth, 
	width, 
	height, 
	independent, 
	onClick 
}) =>{
	return ((independent === false) ? (
		<path 
			d={d} 
			fill={fill} 
			stroke={stroke} 
			strokeWidth={strokeWidth} 
			transform={transform}
			width={width}
			height={height}
		/>
	):(
		<div 
			className={selected === false ? "figure" : "figure selected-figure"} 
			onClick={ () => onClick(id)}>
				<svg
					key="svg1"
					version="1.1"
					width={width}
					height={height}
					viewBox="0 0 200 200"
					xmlns="http://www.w3.org/2000/svg"
					xmlSpace="preserve">
					<path 
						d={d} 
						fill={fill} 
						stroke={stroke} 
						strokeWidth={strokeWidth} 
						transform={transform}
					/>
				</svg>
		</div>
	)
	)
}

Figure.defaultProps = {
  angle:0,
  independent: false,
  selected: false,
  strokeWidth: 0,
  stroke: "#000",
}

export default Figure;


// WEBPACK FOOTER //
// ./src/components/mosaic/figure.jsx